/* global axios */
import ApiClient from './ApiClient';

class SalesPendingChargesAPI extends ApiClient {
  constructor() {
    super('sales_transactions', { accountScoped: true });
  }

  pendingChargeUrl(transactionId, installmentId) {
    return `${this.url}/${transactionId}/pending_charges/${installmentId}`;
  }

  show(transactionId, installmentId) {
    return axios.get(this.pendingChargeUrl(transactionId, installmentId));
  }

  updatePaymentResponsibilities(
    transactionId,
    installmentId,
    responsibilities
  ) {
    return axios.patch(
      `${this.pendingChargeUrl(transactionId, installmentId)}/payment_responsibilities`,
      { responsibilities }
    );
  }

  authorize(transactionId, installmentId) {
    return axios.post(
      `${this.pendingChargeUrl(transactionId, installmentId)}/authorize`
    );
  }

  downloadSheet(installmentId) {
    return axios.get(
      `${this.baseUrl()}/real_estate_commission_installments/${installmentId}/download`,
      { responseType: 'blob' }
    );
  }
}

export default new SalesPendingChargesAPI();
